export default __webpack_public_path__ + "static/media/bicycle-notconnected.e09b9c48.png";